export default "__VITE_ASSET__BMNhEPf6__"